import { useSearchParams } from 'react-router-dom';

/**
 * EXCEÇÃO DELIBERADA ao CLAUDE.md ("Proibido": dado de exemplo).
 *
 * Autorizado por Gabriel Pereira (dono do produto) em conversa com Carlielson
 * G. As., 2026-08-21: o módulo financeiro ainda não tem API nem banco, e o
 * front desta fase precisa ser validado com dado — inclusive nos estados de
 * carregando e erro, que o esqueleto vazio não conseguia mostrar. A pedido
 * dele: "criar um json e alimentar com dados fakes que dê pra testar todas as
 * situações da tela".
 *
 * NÃO REMOVER SEM CONFIRMAR COM O DONO DO PRODUTO DE NOVO. Quando o módulo
 * `financeiro` nascer na API, cada tela troca este gancho por `dados.ts`
 * (padrão de `modulos/admin/integracoes/dados.ts`), e este diretório
 * `_dev/` inteiro sai.
 *
 * `?cenario=` na URL alterna o que a tela mostra, sem precisar mudar código:
 * `carregando`, `vazio`, `erro` ou `sucesso` (padrão).
 */
export type CenarioDeTela = 'carregando' | 'vazio' | 'erro' | 'sucesso';

const CENARIOS: CenarioDeTela[] = ['carregando', 'vazio', 'erro', 'sucesso'];

export function useCenarioDeTela(): CenarioDeTela {
  const [parametros] = useSearchParams();
  const valor = parametros.get('cenario');

  return (CENARIOS as string[]).includes(valor ?? '') ? (valor as CenarioDeTela) : 'sucesso';
}
